<script>
    export default {
        props: {
            to: {
                type: Object,
                default: null
            }
        },
        render (createElement) {
            return createElement('router-link', {
                class: [
                    'table-row',
                    'text-inherit',
                    'no-underline',
                    'hover:text-blue'
                ].join(' '),
                attrs: {
                    to: this.to
                }
            }, this.$slots.default)
        }
    }
</script>
